//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AdGroup',
  data() {
    return {
      isAd1Empty: this.isAdsEmpty,
      isAd2Empty: this.isAdsEmpty
    }
  },
  computed: {
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    },
    isProduction() {
      return process.env.NODE_ENV === 'production'
    },
    isAdsEmpty() {
      return (
        typeof navigator === 'undefined' ||
        navigator.userAgent.includes('Chrome-Lighthouse') ||
        navigator.userAgent.includes('Googlebot') ||
        (this.isAd1Empty && this.isAd2Empty)
      )
    },
    isFromHome() {
      return this.$route.name === 'index'
    }
  }
}
